module.exports = __webpack_public_path__ + "img/cloud_tool_boxplot.7847a196.jpg";